import React, {
  CSSProperties,
  forwardRef,
  ReactNode,
  useImperativeHandle,
  useRef,
} from 'react'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import { Scrollbars as CustomScrollbars } from 'react-custom-scrollbars-2'

import classes from './styles.module.scss'

export interface IScrollbarsProps {
  noScroll?: boolean
  innerStyle?: CSSProperties
  id?: string
  autoHeight?: boolean
  style?: CSSProperties
  children: ReactNode
  className?: string
}

const Scrollbars = forwardRef(
  (
    {
      children,
      noScroll,
      innerStyle,
      id,
      autoHeight,
      style = {},
      className,
    }: IScrollbarsProps,
    refParent,
  ) => {
    const scrollbar = useRef<any>(null)
    useImperativeHandle(refParent, () => ({ scrollToTop }))

    function scrollToTop() {
      scrollbar.current.scrollTop(0)
    }

    if (noScroll) {
      return <>{children}</>
    }

    return (
      <CustomScrollbars
        autoHide
        autoHeight={autoHeight}
        renderView={(props: any) => (
          <div
            {...props}
            id={id}
            className={`${classes.view} ${className}`}
            style={{ ...props.style, ...innerStyle }}
          />
        )}
        renderTrackHorizontal={(props: any) => (
          <div
            {...props}
            style={{ display: 'none' }}
            className={classes.horizontal_track}
          />
        )}
        renderThumbHorizontal={(props: any) => (
          <div {...props} className={classes.horizontal_thumb} />
        )}
        className={classes.inner_list}
        ref={scrollbar}
        style={style}
      >
        {children}
      </CustomScrollbars>
    )
  },
)

Scrollbars.displayName = 'Scrollbars'

export default Scrollbars
